import React, { useState } from "react";
import { Stack } from '@mui/material';
import { useDispatch } from 'react-redux';
import { FEATURE_CUSTOM_REDUX, FEATURE_CUSTOM_REDUX_V2 } from '../../constant';
import { setInvitedUserMState } from '../../redux/tool-webjam-v3/actions';
import { setUserIsLogin, setUserLoginData } from '../../redux/tool-webjam/actions';
import { calculateTimeDiff, getBaseConfig, getStore, isSocialMobileApp } from '../../Utils';
import { useDevice, ValidateEmail, ValidateUsername } from '../../welcome-dashboard/Utils';
import { useEffect } from "react";
import { messages } from "../../welcome-dashboard/messages";
import { loginGuestUser } from "../../welcome-dashboard/Request.d";
import toast from "react-simple-toasts";
import { setPrejoinPageVisibility } from "../../../prejoin/actions.web";
import { getMySubscription } from "../../welcome-dashboard/paymentRequest";
import { CURRENT_ROOM_NAME } from "../../../webjam/constant";
import { updateSettings } from "../../../base/settings";
import Dialog from "../../../base/ui/components/web/Dialog";
import { ct } from "../../constant-Utils";

const errorStyle = { marginTop: '0px', color: 'var(--theme-error-color)' };
const inputStyle = { marginBottom: '0px !important' };

export const InviteRegisterModal = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const {
    userLoginData,
  } = getStore(FEATURE_CUSTOM_REDUX)

  const {
    authOrganization
  } = getStore(FEATURE_CUSTOM_REDUX_V2)
  const [isLoading, setIsLoading] = useState(false);

  const [errors, setErrors] = useState({
    email: "",
    username: ""
  });

  const [userDetail, setUserDetail] = useState({
    email: "",
    username: "",
    guest_id: "",
    room_id: "",
    organization_id: ""
  });

  const handleChange = (e) => {
    const {
      name,
      value
    } = e.target;

    if (errors.email && name === "email") {
      setErrors((e) => ({ ...e, email: "" }))
    }

    if (errors.username && name === "username") {
      setErrors(e => ({ ...e, username: "" }))
    }

    let details = { ...userDetail, [name]: value }
    if (name == "email") {
      details = { ...userDetail, email: (value?.trim())?.toLowerCase() }
    }
    setUserDetail(details)
  }

  useEffect(() => {
    console.log("errors", errors);
  }, [errors])

  useEffect(() => {
    let guestInfo = localStorage.getItem('guestInfo');
    if (guestInfo) {
      try {
        guestInfo = JSON.parse(guestInfo);
        // 30 Days = 2592000 seconds
        if (calculateTimeDiff(guestInfo.setTime, 2592000)) {
          setUserDetail({ email: guestInfo.email, username: guestInfo.username })
        }
      } catch (error) {
        console.log("Invalid Json :", error);
      }
    }
  }, [])


  const handleSubmit = async () => {

    let allErrors = { ...errors }
    let guestInfo = {};

    console.log("userDetail submit", userDetail)
    if (!userDetail.username) {
      allErrors.username = ct("messages.inviteNameValidation", "messages");
      setErrors(allErrors)
      return false;
    } else if (userDetail.username.length < 3) {
      allErrors.username = ct("messages.inviteNameLength", "messages");
      setErrors(allErrors)
      return false;
    } else if (!ValidateUsername(userDetail.username)) {
      allErrors.username = ct("messages.inviteNameInvalid", "messages");
      setErrors(allErrors)
      return false;
    } else if (!userDetail.email) {
      allErrors.email = ct("messages.inviteEmailRequired", "messages");
      setErrors(allErrors)
      return false;
    } else if (!ValidateEmail(userDetail.email)) {
      allErrors.email = ct("messages.inviteEmailInvalid", "messages");
      setErrors(allErrors)
      return false;
    } else {
      setErrors({
        email: "",
        username: ""
      })
      // console.log("userLoginData ", userLoginData)
      let _detail = { ...userDetail };
      _detail.guest_id = userLoginData.user.guest_id;
      _detail.room_id = userLoginData?.room?.id || userLoginData?.room?._id;
      _detail.organization_id = authOrganization._id;
      setUserDetail(_detail);
      setIsLoading(true);

      setTimeout(function () {
        // rehit api if in pending state
        let store_v1 = getStore(FEATURE_CUSTOM_REDUX);
        if (!store_v1.userLoginData.user?.id && store_v1.userLoginData.user?.is_invited == true && !store_v1.conferenceJoined) {
          toast(ct("Translate.messages.unableToProcess"));
          window.location.reload();
        }
      }, 20000)
      setLoading(true);
      let userCreated = await loginGuestUser(_detail);

      if (userCreated.status == 1) {
        let loginDetail = { ...userLoginData };
        console.log("=> loginDetail ", loginDetail)
        loginDetail.user = {
          ...loginDetail.user,
          ...userCreated.data,
          room_name: CURRENT_ROOM_NAME
        }

        console.log("=> loginDetail 2 ", loginDetail);
        localStorage.setItem("auth", JSON.stringify(loginDetail.user));
        dispatch(setUserLoginData(loginDetail, "guest auth saved"))
        dispatch(setUserIsLogin(true));
        setTimeout(function () {
          dispatch(getMySubscription(null, 4));
          dispatch(setPrejoinPageVisibility(false));
          dispatch(setInvitedUserMState(false));
          setIsLoading(false);
        }, 2000)
        let setTime = Math.round(new Date().getTime() / 1000);
        guestInfo['username'] = userDetail.username;
        guestInfo['email'] = userDetail.email;
        guestInfo['setTime'] = setTime;
        localStorage.setItem('guestInfo', JSON.stringify(guestInfo));
        dispatch(updateSettings({
          displayName: guestInfo.username
        }));
      } else {
        setIsLoading(false);
        toast(ct("rta-trmc.dashboard.subscription.failed"))
      }
      setLoading(false);
      console.log("Usewr ceeaeee ted ", _detail)
    }
  }


  const { isMobile } = useDevice();




  if (CURRENT_ROOM_NAME.length < 2) {
    return null;
  }

  return (
    <>
      <Dialog
        disableAutoHideOnSubmit={true}
        disableBackdropClose={true}
        hideCloseButton={true}
        onCancel={() => {
          if (isSocialMobileApp()) {
            window.location.href = getBaseConfig("appReferrerUrl");
          } else {
            // social url change code
            let socialAllowed = getBaseConfig("socialAllowed");
            if (socialAllowed == true) {
              window.parent.location.href = getBaseConfig("socialBaseUrl") + '/';
            } else {
              window.location.href = "/"
            }
          }
        }}
        onSubmit={() => handleSubmit()}
        cancel={{ translationKey: ct("Translate.buttonTitle.closeSmall"), disabled: loading }}
        ok={{ translationKey: ct("Translate.buttonTitle.submit"), disabled: loading }}
        titleKey={ct("rta-trmc.dialogs.enterDetails")}
        rtaClassName="invite-modal-dialog"
        testId="invite-modal-popup"
      >
        <div className={`login-form mt-2`}>
          <Stack spacing={1}>
            <label htmlFor="name" id='user-name'>{ct("rta-trmc.dialogs.name")}:</label>
            <input
              style={inputStyle}
              name='username'
              type="text"
              value={userDetail.username}
              className="form-control input-control mb-0"
              id="login-name-field"
              placeholder={ct("messages.inviteNameValidation", "messages")}
              onChange={handleChange}
            />
            {errors.username ? <span style={errorStyle}>{errors.username}</span> : null}
            <label htmlFor="userEmail" id='user-email-label'>{ct("rta-trmc.dialogs.email")}:</label>
            <input
              style={inputStyle}
              name='email'
              type="text"
              value={userDetail.email}
              className="form-control input-control mb-0"
              id="login-email-field"
              placeholder={ct("rta-trmc.dialogs.enterEmail")}
              onChange={handleChange}
            />
            {errors.email ? <span style={errorStyle}>{errors.email}</span> : null}
          </Stack>
        </div>
      </Dialog>
    </>
  );
}
